export default {
  title: 'light',
  colors: {
    primary: '#C50022',
    secondary: '#F39500',
    tertiary: '#004A96',

    background: '#F7F8FE',
    backgroundSecondary: '#EAEBEE',
    backgroundTertiary: '#D9DADD',

    placeholder: '#666360',
    text: '#333',
    textSecondary: '#F5F5F5',

    golden: '#B67102', /*'#F29602',*/

    mainColor: '#F39500',
    secondaryColor: '#FED39D',

    error: '#C53030',
    errorText: '#fddede',

    success: '#28A745',
    sucessText: '#CAFFD5',
  },
}
